/* Desenlace de la oferta, vocabulario cerrado. Vive junto al seguimiento porque es la
 * misma decisión («qué hice con este proceso»), pero no se poda con el cierre. */
import { RESULTADOS_OFERTA, type ResultadoOferta } from '../api/tipos'
import './QuePaso.css'

export function QuePaso({ actual, onElegir }: {
  actual?: ResultadoOferta
  onElegir: (r: ResultadoOferta | null) => void
}) {
  return (
    <div className="que-paso">
      <p className="rotulo">¿Qué pasó?</p>
      <div className="que-paso-ops">
        {RESULTADOS_OFERTA.map((r) => (
          <button
            key={r.clave}
            type="button"
            className={`accion${actual === r.clave ? ' puesta' : ''}`}
            aria-pressed={actual === r.clave}
            onClick={() => onElegir(actual === r.clave ? null : r.clave)}
          >
            {r.etiqueta}
          </button>
        ))}
      </div>
    </div>
  )
}
